import classNames from 'classnames';

export const SpreedlyPaymentButton = ({
  isDisabled
}: Record<string, boolean>) => {
  return (
    <input
      id="submit-button"
      type="button"
      value="Pagar"
      disabled={isDisabled}
      className={classNames(
        'hover:co-bg-primary-500 active:co-bg-primary-500 co-w-full co-border-[1px] co-border-gray-200 co-p-2 co-rounded-[100px] co-px-32px co-py-12px co-font-semibold co-text-body1 co-cursor-pointer co-bg-primary-400 co-text-white',
        {
          '!co-bg-[#E6E6E6] !co-text-[#7E7E7E] !co-cursor-not-allowed':
            isDisabled
        }
      )}
    />
  );
};
